module.exports = __webpack_public_path__ + "img/23.9db3e5c3.jpg";